<template>
  <div id="app">
    <OpeningLayer v-if="isLandingPage"/>
    <transition
      :name="transitionName"
    >
      <router-view :key="routerKey"/>
    </transition>
    <PageControl :left="true" :right="true" :up="false" :down="true" />
    <VerticalLogo />
    <ElevatorButtons />
    <GlobalNavPc />
    <MobileMenu />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import VerticalLogo from '@/components/VerticalLogo'
import PageControl from '@/components/PageControl'
import GlobalNavPc from '@/components/GlobalNavPc'
import MobileMenu from '@/components/MobileMenu'
import ElevatorButtons from '@/components/ElevatorButtons'
import OpeningLayer from '@/components/OpeningLayer'

const DEFAULT_TRANSITION = 'tab'

export default {
  components: {
    VerticalLogo, PageControl, GlobalNavPc, MobileMenu, ElevatorButtons, OpeningLayer
  },
  data() {
    return {
      transitionName: DEFAULT_TRANSITION
    }
  },
  created() {

    this.$router.beforeEach((to, from, next) => {
      // console.log(to)
      if (to.params.notransition) {
        this.transitionName = transitionName || DEFAULT_TRANSITION;
        next()
        return
      }
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === 'slide') {
        const toPath = to.path.split('/')
        const toDepth = toPath[1] == ''? 1: toPath.length;
        
        const fromPath = from.path.split('/')
        const fromDepth = fromPath[1] == ''? 1: fromPath.length;
        if (to.params.pageNo && from.params.pageNo) {
          if (from.params.pageNo > to.params.pageNo) {
            transitionName = 'slide-up';
          } else {
            transitionName = 'slide-down';
          }
        } else {
          transitionName = toDepth < fromDepth ? 'slide-up' : 'slide-down';
        }
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
    // let hash = location.hash
    // console.log(hash)

  },
  mounted() {

    // console.log(this.$route.path)
  },
  computed: {
    ...mapState({
      openingEffected: state => state.openingEffected,
    }),

    routerKey() {
      if (this.$route.name === 'Home') {
        return this.$route.name
      } else {
        return this.$route.fullPath
      }
    },
    isLandingPage() {
      if (this.openingEffected) {
        // 表示済みなので2回め以降の表示はしない
        return false
      }
      if (this.$route.name === 'Home') {
        if (!location.hash || location.hash === '#top') {
          this.setOpeningEffected(true)
          return true
        } else {
          this.setOpeningEffected(true)
          return false
        }
      } else {
        this.setOpeningEffected(true)
        return false
      }
    }
  },
  methods: {
    ...mapActions({
      setOpeningEffected: 'doSetOpeningEffected'
    }),

  }
}
</script>

<style lang="scss">
.slide-down-enter {
  transform: translate(0px, 100px);
  opacity: 0;
}
.slide-down-enter-to {
  opacity: 1;
}
.slide-down-enter-active {
  transition: all .6s 0s ease;
  position: fixed;
  top: 0;
}
.slide-down-leave {
  transform: translate(0, 0);
  opacity: 1;
}
.slide-down-leave-to {
  transform: translate(0px, -100px);
  opacity: 0;
}
.slide-down-leave-active {
  transition: all .3s 0s ease;
  .swiper-wrapper {
    transform: translate3d(-200vw, 0px, 0px);
  }
  &.swipe-1 {
    .swiper-wrapper {
      transform: translate3d(-100vw, 0px, 0px);
    }
  }
}

.slide-up-enter {
  transform: translate(0px, -100px);
  opacity: 0;
}
.slide-up-enter-to {
  opacity: 1;
}
.slide-up-enter-active {
  transition: all .6s 0s ease;
  position: fixed;
  top: 0;
}
.slide-up-leave {
  transform: translate(0, 0);
  opacity: 1;
}
.slide-up-leave-to {
  transform: translate(0px, 100px);
  opacity: 0;
}
.slide-up-leave-active {
  transition: all .3s 0s ease;
}
</style>
